import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import telemetryService from '../services/telemetryService';

// Diccionario de nombres descriptivos para cada ruta de la aplicación Web
const ROUTE_NAME_MAP = {
  '/': 'Inicio / Login',
  '/inicio': 'Panel de Inicio',
  '/clientes': 'Gestión de Clientes',
  '/clientesadd': 'Registro de Clientes',
  '/clientesactivos': 'Clientes Activos',
  '/clientesasesorcastigados': 'Clientes Castigados',
  '/cuadrecaja': 'Cuadre de Caja',
  '/cuadrecajaadd': 'Nuevo Cuadre de Caja',
  '/cuadrecajaview': 'Detalle de Cuadre de Caja',
  '/cobranzadiaria': 'Cobranza Diaria',
  '/junta': 'Gestión de Juntas',
  '/juntaadd': 'Nueva Junta',
  '/juntaplan': 'Plan de Juntas',
  '/juntaplanadd': 'Nuevo Plan de Junta',
  '/prestamos': 'Listado de Préstamos',
  '/prestamosadd': 'Nuevo Préstamo',
  '/prestamosactivos': 'Préstamos Activos',
  '/prestamosall': 'Todos los Préstamos',
  '/prestamosrcc': 'Reporte RCC Préstamos',
  '/prestamocastigar': 'Castigo de Préstamos',
  '/egresos': 'Gestión de Egresos',
  '/pagosotros': 'Otros Pagos',
  '/reportes': 'Reportes Generales',
  '/calculadora': 'Calculadora de Préstamos',
  '/usuarios': 'Gestión de Usuarios',
  '/perfil': 'Mi Perfil',
  '/perfiledit': 'Editar Perfil',
  '/perfileditpass': 'Cambiar Contraseña',
  '/notificaciones': 'Historial de Notificaciones',
  '/projectprogress': 'Progreso del Proyecto',
  '/dev-tasks': 'Gestor de Tareas Dev',
};

export const getScreenNameFromPath = (pathname) => {
  if (!pathname) return 'Desconocida';
  const cleanPath = pathname.toLowerCase().trim();
  
  if (ROUTE_NAME_MAP[cleanPath]) {
    return ROUTE_NAME_MAP[cleanPath];
  }

  // Rutas dinámicas
  if (cleanPath.startsWith('/clientes/edit/') || cleanPath.startsWith('/clienteseditar/')) {
    return 'Editar Cliente';
  }
  if (cleanPath.startsWith('/clientesver/') || cleanPath.startsWith('/clientes/ver/')) {
    return 'Ver Detalle Cliente';
  }
  if (cleanPath.startsWith('/clientesdocument/')) {
    return 'Documentos de Cliente';
  }
  if (cleanPath.startsWith('/prestamo/')) {
    return 'Detalle de Préstamo';
  }
  if (cleanPath.startsWith('/junta/')) {
    return 'Detalle de Junta';
  }
  if (cleanPath.startsWith('/juntaplan/')) {
    return 'Detalle de Plan Junta';
  }

  // Formato por defecto para rutas no mapeadas
  const segment = cleanPath.replace(/^\//, '').split('/')[0];
  if (segment) {
    return segment.charAt(0).toUpperCase() + segment.slice(1);
  }

  return 'Pantalla Web';
};

/**
 * Componente silencioso que rastrea cambios de ruta en React Router
 * y envía automáticamente la telemetría al backend.
 */
export default function RouteTracker() {
  const location = useLocation();
  const lastPathRef = useRef('');
  const entryTimeRef = useRef(Date.now());

  useEffect(() => {
    const currentPath = location.pathname;
    const now = Date.now();

    // Calcular duración en la pantalla anterior si existía
    if (lastPathRef.current && lastPathRef.current !== currentPath) {
      const durationSeconds = Math.round((now - entryTimeRef.current) / 1000);
      const prevScreen = getScreenNameFromPath(lastPathRef.current);
      // Opcional: enviar duración de la pantalla previa
      if (durationSeconds > 1 && durationSeconds < 7200) {
        telemetryService.trackScreenView(prevScreen, lastPathRef.current, durationSeconds);
      }
    }

    // Registrar ingreso a la nueva pantalla
    const screenName = getScreenNameFromPath(currentPath);
    telemetryService.trackScreenView(screenName, currentPath);

    lastPathRef.current = currentPath;
    entryTimeRef.current = now;
  }, [location.pathname]);

  return null;
}
